export default{
    lang:"ko",
    fontFamily:"en-font-family",
    fontFamilyTitle:"en-font-family-title",
}